import { maxLength, ValidationField, Validator, dateFormat } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
export class RsyncFindConditionValidator extends Validator {
    constructor(data) {
        const dateFormatErrorMessage = commonStore.messages.PV0005;
        const constraints = {
            failureDateFrom: {
                dateFormat: dateFormat(dateFormatErrorMessage)
            },
            failureDateTo: {
                dateFormat: dateFormat(dateFormatErrorMessage)
            },
            userCd: {
                length: maxLength(8)
            },
            userName: {
                length: maxLength(30)
            },
            buknCd: {
                length: maxLength(8)
            },
            buknName: {
                length: maxLength(30)
            },
            nyukyokeiyakuNo: {
                length: maxLength(8)
            },
            nyukyoshaName: {
                length: maxLength(30)
            }
        };
        super(data, constraints);
        this.failureDateFrom = new ValidationField("failureDateFrom", data, constraints);
        this.failureDateTo = new ValidationField("failureDateTo", data, constraints);
        this.userCd = new ValidationField("userCd", data, constraints);
        this.userName = new ValidationField("userName", data, constraints);
        this.buknCd = new ValidationField("buknCd", data, constraints);
        this.buknName = new ValidationField("buknName", data, constraints);
        this.nyukyokeiyakuNo = new ValidationField("nyukyokeiyakuNo", data, constraints);
        this.nyukyoshaName = new ValidationField("nyukyoshaName", data, constraints);
    }
    failureDateFrom;
    failureDateTo;
    userCd;
    userName;
    buknCd;
    buknName;
    nyukyokeiyakuNo;
    nyukyoshaName;
}
